import WelcomeForm from './WelcomeForm';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

function mapStateToProps(state) {
  return {
    viewportWidth: state.main.get('viewportWidth'),
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onNext: () => dispatch(push(ownProps.nextRoute)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WelcomeForm);



// WEBPACK FOOTER //
// ./src/components/welcome/WelcomeComponent.js